<template>
	<v-form ref="form" v-model="valid">
		<v-row>
			<v-col :sm="6" :lg="4">
				<v-autocomplete outline
					style="transform: translateY(12px);"
					v-model="pageData.name"
					:items="pageData.nameItems"
					:loading="pageData.nameIsLoading"
					:search-input.sync="pageData.searchName"
					:no-data-text="$lib.translate('Ничего не найдено')"
					item-text="translate.ru.name"
					return-object
					:label="$lib.translate('Судья')"
					:rules="[$rules.required]"
					class="mb-4"
				></v-autocomplete>
				<v-select
					v-model="pageData.type"
					:items="items"
					item-text="text"
					item-value="value"
					:label="$lib.translate('Тип запроса')"
					@change="change"
				></v-select>
				<v-autocomplete outline
					style="transform: translateY(12px);"
					v-model="pageData.name2"
					:items="pageData.nameItems2"
					:loading="pageData.nameIsLoading2"
					:search-input.sync="pageData.searchName2"
					:no-data-text="$lib.translate('Ничего не найдено')"
					item-text="translate.ru.name"
					return-object
					:label="pageData.type === 1 ? $lib.translate('ФИО') : $lib.translate('Название')"
					:rules="[$rules.required]"
				></v-autocomplete>
				<v-btn color="primary" @click="next" class="mt-4">{{ $lib.translate('Дальше') }}</v-btn>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
	export default {
		name: 'SearchStep1',

		data () {
			return {
				items: [
					{value: 1, text: this.$lib.translate('Физ. лицо')},
					{value: 2, text: this.$lib.translate('Компания')},
				],
				pageData: {
					type: 1,

					name: null,
					searchName: '',
					nameItems: [],
					nameIsLoading: false,
					timeoutId: null,

					name2: null,
					searchName2: '',
					nameItems2: [],
					nameIsLoading2: false,
					timeoutId2: null,

					relations: []
				},
				valid: true
			}
		},

		created () {
			this.pageData = Object.assign({}, this.pageData, this.$store.getters.PAGE('step1'));
		},

		beforeDestroy() {
			this.pageData.nameIsLoading = false;
			this.pageData.nameIsLoading2 = false;
			this.$store.dispatch('SET_PAGE', {
				page: 'step1',
				data: this.pageData
			});
		},

		watch: {
			'pageData.searchName' (val) {
				clearTimeout(this.timeoutId);
				if (val) {
					this.timeoutId = setTimeout(() => {
						this.pageData.nameIsLoading = true;
						this.$api.get('listSearch', {
							params: {
								limit: 50,
								judge: 1,
								except_ids: this.pageData.name2 ? [this.pageData.name2.id] : null,
								name: val
							}
						}).then((response) => {
							this.pageData.nameItems = response.data.data;
							this.pageData.nameIsLoading = false;
						});
					}, 500);
				} else {
					this.pageData.name = null;
				}
			},

			'pageData.searchName2' (val) {
				clearTimeout(this.timeoutId2);
				if (val) {
					this.timeoutId2 = setTimeout(() => {
						this.pageData.nameIsLoading2 = true;
						const apiName = this.pageData.type === 1 ? 'listSearch' : 'companiesListSearch';
						const apiParams = this.pageData.type === 1 ? {
							limit: 50,
							name: val,
							except_ids: this.pageData.name ? [this.pageData.name.id] : null,
						} : {
							limit: 50,
							name: val
						};
						this.$api.get(apiName, {
							params: apiParams
						}).then((response) => {
							this.pageData.nameItems2 = response.data.data;
							this.pageData.nameIsLoading2 = false;
						});
					}, 500);
				} else {
					this.pageData.name2 = null;
				}
			}
		},

		methods: {
			next () {
				this.$refs.form.validate();
				if (this.valid) {
					const apiName = this.pageData.type === 1 ? 'judgePerson' : 'judgeCompany';
					const apiParamsType = this.pageData.type === 1 ? 'person' : 'company';

					this.$api.get(apiName, {
						params: {
							judge: this.pageData.name.id,
							[apiParamsType]: this.pageData.name2.id
						}
					}).then((response) => {
						this.pageData.relations = response.data.data;
						this.$store.dispatch('SET_PAGE', {
							page: 'step1',
							data: this.pageData
						});
						this.$store.dispatch('SET_STEP', 2);
					});
				}
			},
			change () {
				this.pageData.name2 = null;
				this.pageData.nameItems2 = [];
				this.pageData.searchName2 = '';
				this.pageData.nameIsLoading2 = false;
				this.pageData.timeoutId2 = null;
			}
		}
	}
</script>
